const Footer = () => {
    return ( 
        <div className="footer-wrapper">
            <span>© Hugo Folloni Guarilha {new Date().getFullYear()}</span>
        </div>
     );
}
 
export default Footer;